// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"b2f4b03a","391":"13826661","832":"13826661","926":"13826661"}[chunkId] + ".chunk.css";
};